module.exports = __webpack_public_path__ + "img/Integridade.d21a037c.png";